/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ exercise: NonNullable<unknown>, equipment: NonNullable<unknown> }} Progression_Equipment_No_SubstituteInputs */

const en_us2_progression_equipment_no_substitute = /** @type {(inputs: Progression_Equipment_No_SubstituteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} needs a ${i?.equipment} and nothing else fits`)
};

const pt_br2_progression_equipment_no_substitute = /** @type {(inputs: Progression_Equipment_No_SubstituteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} precisa de ${i?.equipment} e nada mais serve`)
};

const es_419_progression_equipment_no_substitute = /** @type {(inputs: Progression_Equipment_No_SubstituteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} necesita ${i?.equipment} y nada más sirve`)
};

const pt_pt2_progression_equipment_no_substitute = /** @type {(inputs: Progression_Equipment_No_SubstituteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} precisa de ${i?.equipment} e nada mais serve`)
};

const fr_fr2_progression_equipment_no_substitute = /** @type {(inputs: Progression_Equipment_No_SubstituteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} nécessite ce matériel : ${i?.equipment}, et rien d'autre ne convient`)
};

const de_de2_progression_equipment_no_substitute = /** @type {(inputs: Progression_Equipment_No_SubstituteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} braucht ${i?.equipment}, und nichts anderes passt`)
};

const it_it2_progression_equipment_no_substitute = /** @type {(inputs: Progression_Equipment_No_SubstituteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.exercise} richiede ${i?.equipment} e nient'altro va bene`)
};

/**
* | output |
* | --- |
* | "{exercise} needs a {equipment} and nothing else fits" |
*
* @param {Progression_Equipment_No_SubstituteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progression_equipment_no_substitute = /** @type {((inputs: Progression_Equipment_No_SubstituteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progression_Equipment_No_SubstituteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progression_equipment_no_substitute(inputs)
	if (locale === "es-419") return es_419_progression_equipment_no_substitute(inputs)
	if (locale === "pt-PT") return pt_pt2_progression_equipment_no_substitute(inputs)
	if (locale === "fr-FR") return fr_fr2_progression_equipment_no_substitute(inputs)
	if (locale === "de-DE") return de_de2_progression_equipment_no_substitute(inputs)
	if (locale === "it-IT") return it_it2_progression_equipment_no_substitute(inputs)
	return en_us2_progression_equipment_no_substitute(inputs)
});
export { progression_equipment_no_substitute as "progression.equipment_no_substitute" }